export default {
  name: 'splitSlideshow',
  component() {
    return {
      currentIndex: 1,
      totalSlides: 1,
      init() {
        const textSwiper = this.$refs.textSwiper;
        const mediaSwiper = this.$refs.mediaSwiper;

        if (textSwiper && mediaSwiper) {
          const syncSwipers = () => {
            if (textSwiper.swiper && mediaSwiper.swiper) {
              textSwiper.swiper.controller.control = mediaSwiper.swiper;
              mediaSwiper.swiper.controller.control = textSwiper.swiper;
              
              // Handle active videos for initial state
              this.toggleVideos(mediaSwiper.swiper);
              this.totalSlides = parseInt(this.$el.dataset.totalSlides) || 1;

              textSwiper.addEventListener('swiperslidechange', (event) => {
                const swiper = event.detail[0];
                this.currentIndex = swiper.realIndex + 1;
              });

              // Pause/play videos on slide change
              mediaSwiper.addEventListener('swiperslidechangetransitionend', (event) => {
                const swiper = event.detail[0];
                this.toggleVideos(swiper);
              });

            } else {
              setTimeout(syncSwipers, 50);
            }
          };
          syncSwipers();
        }
      },
      toggleVideos(swiper) {
        if (!swiper) return;
        const { activeIndex, previousIndex } = swiper;
        
        if (previousIndex !== undefined) {
          const prevSlide = swiper.slides[previousIndex];
          if (prevSlide) prevSlide.querySelectorAll('video').forEach(v => v.pause());
        }

        const activeSlide = swiper.slides[activeIndex];
        if (activeSlide) activeSlide.querySelectorAll('video').forEach(v => v.play());
      }
    }
  }
}
